module.exports = __webpack_public_path__ + "static/media/pilot02.16ed3fd4.jpg";